import useArticleMetadataValues from "../../../hooks/useArticleMetadataValues";

import getVersionFields from "../utils/getVersionFields";

const keys = [
	"status",
	"isbn",
	"name",
	"subtitle",
	"announcementDate",
	"releaseDate",
	"takedownDate",
	"authors",
	"translators",
	"countries",
	"imprint",
	"duration",
	"epubVersion",
	"accessibility",
	"serie",
	"originalName",
	"language",
	"originalLanguage",
	"additionalLanguages",
	"synopsis",
	"hazardsOrWarnings",
	"prices",
	"bokgruppe",
	"themaCodes",
	"mainThemaCode",
	"bisacCodes",
	"tags",
	"abridged",
];

export default function useArticleVersionsModalFields(version) {
	const getValues = useArticleMetadataValues();

	return getVersionFields(getValues, keys, version?.before, version?.after);
}
